import React from 'react';
import $ from 'jquery';
import OrderService from '../services/order.js';
import CurrencyService from '../services/currency';
import Utility from '../utilities/utility.js';
import AuthorizationCheck from '../auth/authorizationCheck.js';
import CountryService from '../services/country.js';
import BranchService from '../services/branch.js';

class NewOrder extends React.Component {

    constructor(props) {

        super(props);

        this.currencyService = new CurrencyService();
        this.countryService = new CountryService();
        this.branchService = new BranchService();

        this.state = {
            item: '',
            currencies: [],
            branches : [],
            countries : [],
            currentUserRole: '',
        }
    }

    componentDidMount(){

        this.currencyList();
        this.countryList();
        
    }

    setRole = (role) => {

        this.setState({ currentUserRole: role });
    }

    async createOrder() {

        try {

            let description = $('#descriptionId').val();

            let currencyId = $('#currencyId').val();
            let branchId = $('#branchId').val();
            let countryId = $('#countryId').val();

            if (!Utility.isEmpty(branchId) && Utility.isEmpty(countryId)) {

                Utility.showAlert('messageHolder', 'Veillez choisir le pays', 'danger', true);


                return;
            }

            if (Utility.isEmpty(description) || Utility.isEmpty(currencyId)) {

                $('.messageHolder').html(

                    '<div class="alert alert-danger order-alert">Entrer la description et la devise</div>'
                );

                $('.order-alert').delay(600).fadeOut('slow');

                return;
            }


            const response = await OrderService.createOrder(description, currencyId, branchId, countryId);

            if (response.ok) {

                $('.messageHolder').html(

                    '<div class="alert alert-success">Nouvelle commande crée</div>'
                );
            } else {

                $('.messageHolder').html(

                    '<div class="alert alert-danger">Erreur</div>'
                );

            }
        } catch (error) {


            console.log(error);
            $('.messageHolder').html(

                '<div class="alert alert-danger">Erreur</div>'
            );
        }





    }

    currencyList = async () => {

        try {

            const response = await this.currencyService.currencyList();

            this.setState({

                currencies: await response.json()
            })

        } catch (error) {
            console.log(error)
        }

    }

    branchList = async () => {

        try {

            let countryId = $('#countryId').val();

            if(Utility.isEmpty(countryId)){

                Utility.showAlertWithId('messageHolder', 'Veillez choisir le pays', 'danger', true);

                return;
            }
            let name = $('#searchName').val();

            const response = await this.branchService.branchList(countryId, name);

            this.setState({

                branches: await response.json()
            });
        } catch (error) {

            console.log(error);
        }


    }

    countryList = async () => {

        try {

            const response = await this.countryService.fetchCountries();

            this.setState({

                countries: await response.json()
            })

        } catch (error) {
            console.log(error)
        }

    }

    render() {

        

        const { item } = this.state;

        const currencies = this.state.currencies;
        const countries = this.state.countries;
        const branches = this.state.branches;

        let countrySelection = '';

        let branchSelection = '';


        if (this.state.currentUserRole == 'MANAGER' || this.state.currentUserRole == 'SUPER-ADMIN') {


            countrySelection = <div className="row">
                <div className="col-md-12">
                    <div className="form-group">
                        <label className="label">Choisi le Pays</label>
                        <select className="form-control" id="countryId" onChange={this.branchList}>
                            <option></option>
                            {countries.length > 0 && countries.map(country =>

                                <option value={country.countryId}>{country.name}</option>
                            )}
                        </select>
                    </div>
                </div>
            </div>
        }

        if (this.state.currentUserRole == 'MANAGER' || this.state.currentUserRole == 'SUPER-ADMIN') {


            branchSelection = <div className="row">
                <div className="col-md-12">
                    <div className="form-group">
                        <label className="label">Choisi la branche</label>
                        <select className="form-control" id="branchId">
                            <option></option>
                            {!Utility.isEmpty(branches) && branches.map(branch =>

                                <option value={branch.branchId}>{branch.name}</option>
                            )}
                        </select>
                    </div>
                </div>
            </div>
        }



        return (


            <div className="order-wrapper">

           <AuthorizationCheck accessLevel='USER' userRole={this.setRole} />

                <div className="form-wrapper">
                    <h2>Nouvelle Commande</h2>

                    <div className="messageHolder"></div>

                    <div className="form-group row">
                        <input className="form-control" id="descriptionId" placeholder="Description" />
                    </div>

                    <div className="form-group row">
                        <label className='label'>Devise</label>
                        <select className="form-control" id="currencyId" >
                            <option></option>
                            {currencies != undefined && currencies.length > 0 && currencies.map(currency =>

                                <option key={currency.currencyId} value={currency.currencyId}>{currency.name}</option>

                            )}
                        </select>
                    </div>

                    { countrySelection }

                    { branchSelection }

                    <div className="form-group row">
                        <button className="btn btn-primary" onClick={this.createOrder}>Creer Commande</button>
                    </div>


                </div>


            </div>




        );
    }
}

export default NewOrder;